import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { EXPERIMENT_TWO_TEXT_MAX_LENGTH } from '../../validation/validationRules';

export const WorkLifeBalanceDetailsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  return (
    <Textarea
      id="workLifeBalanceDetails"
      label="How well are your personal time and flexibility needs supported?"
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={EXPERIMENT_TWO_TEXT_MAX_LENGTH}
    />
  );
};
